import axios from 'axios';
import axiosJsonpAdapter from 'axios-jsonp';

class ZipCloudApiClient {
  constructor() {
    // this.client = axios.create({
    //   baseURL: 'https://zipcloud.ibsnet.co.jp/api/search',
    //   headers: { 'Content-Type': 'application/json' },
    //   // timeout: REQUEST_TIMEOUT,
    // });
  }

  getAddress(zipcode) {
    return axios.get('https://zipcloud.ibsnet.co.jp/api/search', {
      adapter: axiosJsonpAdapter,
      params: { zipcode },
    });
  }
}

// Singleton
export const zipCloudApiClient = new ZipCloudApiClient();
